import { connect } from 'react-redux'
import {
  loadDeviceHistory,
  promoteDevice,
  startJob,
} from '../../../store/deviceHistory'
import {
  startLensCalibration,
  requestLogUpload,
  requestSpeedTest,
  revokeToken,
  restartDevice,
  calibrateStage,
  requestOnDeviceQCTest,
} from '../../../store/devices'
import { setDeviceDeploymentState } from '../../../store/ui'
import HomeView from '../components/HomeView'

const mapDispatchToProps = {
  loadDeviceHistory,
  promoteDevice,
  calibrateStage,
  setDeviceDeploymentState,
  startJob,
  startLensCalibration,
  requestLogUpload,
  requestOnDeviceQCTest,
  requestSpeedTest,
  revokeToken,
  restartDevice,
}

const mapStateToProps = (state) => ({
  deviceHistory: state.deviceHistory,
  deviceDeploymentState: state.ui.deviceDeploymentState,
  user: state.user,
  jobs: state.jobs,
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeView)



// WEBPACK FOOTER //
// ./src/routes/Home/containers/HomeContainer.js